// lib imports
import React from 'react';
import { Link } from 'react-router-dom';
import { Anchor, Box, Heading, Text } from 'grommet';
import { useHistory } from 'react-router-dom';

// CORE imports
import Divider from 'granite-admin/core/components/Divider';
const Footer = () => {
  const history = useHistory();
  return /*#__PURE__*/React.createElement(Box, {
    background: "brand",
    direction: "row",
    justify: "around",
    gap: "medium",
    pad: {
      horizontal: 'xlarge'
    },
    height: {
      min: '160px'
    },
    wrap: true
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "row",
    justify: "start",
    margin: {
      vertical: 'large',
      left: 'large'
    },
    gap: "xlarge",
    flex: {
      grow: 3
    }
  }, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Heading, {
    color: "#222D39",
    level: 6,
    margin: {
      bottom: 'medium'
    }
  }, "Help"), /*#__PURE__*/React.createElement(Anchor, {
    color: "#222D39",
    size: "small",
    margin: {
      vertical: 'small',
      horizontal: 'xxsmall'
    }
  }, "Help Center"), /*#__PURE__*/React.createElement(Anchor, {
    color: "#222D39",
    size: "small",
    margin: {
      vertical: 'small',
      horizontal: 'xxsmall'
    }
  }, "Help Forum")), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Heading, {
    color: "#222D39",
    level: 6,
    margin: {
      bottom: 'medium'
    }
  }, "Community"), /*#__PURE__*/React.createElement(Anchor, {
    color: "#222D39",
    size: "small",
    margin: {
      vertical: 'small',
      horizontal: 'xxsmall'
    }
  }, "Blogs")), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Heading, {
    color: "#222D39",
    level: 6,
    margin: {
      bottom: 'medium'
    }
  }, "Developers"), /*#__PURE__*/React.createElement(Anchor, {
    color: "#222D39",
    size: "small",
    margin: {
      vertical: 'small',
      horizontal: 'xxsmall'
    }
  }, "API"), /*#__PURE__*/React.createElement(Anchor, {
    color: "#222D39",
    size: "small",
    margin: {
      vertical: 'small',
      horizontal: 'xxsmall'
    }
  }, "Developer Forum"))), /*#__PURE__*/React.createElement(Box, {
    align: "center",
    alignSelf: "end",
    direction: "row",
    flex: {
      grow: 1
    },
    justify: "center",
    margin: {
      vertical: 'large'
    }
  }, /*#__PURE__*/React.createElement(Anchor, {
    onClick: () => history.push('/terms'),
    color: "#222D39",
    size: "small"
  }, /*#__PURE__*/React.createElement(Text, null, "Terms of Service")), /*#__PURE__*/React.createElement(Divider, {
    background: "light-4",
    type: "vertical",
    margin: {
      horizontal: 'medium'
    }
  }), /*#__PURE__*/React.createElement(Anchor, {
    as: "span",
    color: "#222D39",
    size: "small"
  }, /*#__PURE__*/React.createElement(Link, {
    to: "/privacy-policy"
  }, /*#__PURE__*/React.createElement(Text, null, "Privacy"))), /*#__PURE__*/React.createElement(Divider, {
    type: "vertical",
    margin: {
      horizontal: 'medium'
    },
    background: "light-4"
  }), /*#__PURE__*/React.createElement(Anchor, {
    color: "#222D39",
    size: "small"
  }, /*#__PURE__*/React.createElement(Text, null, "Content Policy"))));
};
export default Footer;